const getDiscountPercentage = (price, compare_at_price) => {
  if (price === 0 || compare_at_price === 0) return Infinity;
  const percentage = (price * 100) / compare_at_price;
  return Math.round(100 - percentage);
};

const algoliarecommend = window['@algolia/recommend'];

const redirectTo = (handle) => {
  window.location = `/${handle}`;
};

const faqScroll = (identifier) => {
  const element = document.querySelector(`#${identifier}`);
  element.scrollIntoView({ behavior: 'smooth' });
};

window.addEventListener('popstate', function (event) {
  // Ignore if triggered by a normal hyperlink click
  if (event.state === null) return;

  const entryPage = sessionStorage.getItem('entryPage');

  if (history.length > 1) {
    history.back();
  } else {
    window.location.href = entryPage && entryPage !== window.location.href ? entryPage : '/';
  }
});
